import React from 'react';
import { BsPiggyBank } from 'react-icons/bs';
import { MdAlarm } from 'react-icons/md';

import type { Media as MediaType } from '../../../payload/payload-types';
import { ApplicationHeroProps } from '@/app/_blocks/ApplicationHeroGraphQL/types';
import { Button } from '../Button';
import { Media } from '../Media';

import classes from './ApplicationHero.module.scss';

export const ApplicationHero: React.FC<{
  className?: string;
  applicationHero: ApplicationHeroProps;
}> = ({ className, applicationHero }) => {
  return (
    <div className={[className, classes.wrapper, 'grid'].filter(Boolean).join(' ')}>
      Empty
    </div>
  );
};

export default ApplicationHero;
